<template>
  <div class="honer">
    <div style="display: flex; align-items: flex-end; padding: 5px 0 0px 20px">
      <h2>宣传报道列表</h2>
    </div>
    <div class="sub">
      <el-button type="primary" @click="add">添加报道信息</el-button>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div
        style="display: flex; flex-wrap: wrap"
        class="border"
        v-for="(item, index) in ruleForm.list"
        :key="index"
      >
      {{item.title}}
        <el-form-item
          label="报道标题"
          :prop="'list.' + index + '.title'"
          :rules="rules.title"
          style="width: 70%"
        >
          <el-input v-model="item.title"></el-input>
        </el-form-item>{{item.source}}
        <el-form-item
          label="报道来源"
          :prop="'list.' + index + '.source'"
          :rules="rules.source"
        >
          <el-input v-model="item.source"></el-input>
        </el-form-item>{{item.time}}
        <el-form-item
          label="报道时间"
          :prop="'list.' + index + '.time'"
          :rules="rules.time"
        >
          <el-date-picker
            type="date"
            placeholder="报道时间"
            v-model="item.time"
            style="width: 100%"
             value-format="timestamp"
          ></el-date-picker>
        </el-form-item>{{item.link}}
        <el-form-item
          label="报道链接"
          style="width: 70%"
          :prop="'list.' + index + '.link'"
          :rules="rules.link"
        >
          <el-input v-model="item.link"></el-input>
        </el-form-item>
      </div>
        <el-button type="primary" ref="baodao" @click="submitForm('ruleForm')" style="display:none"
          >立即创建</el-button
        >
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: 1,
      ruleForm: {
        list: [{ title: "", source: "", time: "", link: "" }],
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        source: [
          { required: true, message: "请选择出生日期", trigger: "change" },
        ],
        time: [{ required: true, message: "请选择时间", trigger: "change" }],
        link: [{ required: true, message: "请输入链接", trigger: "blur" }],
      },
    };
  },
  methods: {
    add() {
      this.ruleForm.list.push({
        title: "",
        source: "",
        time: "",
        link: "",
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
           this.$emit('propaganda',this.ruleForm.list) 
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    subClick() {
      console.log(122);
      this.$refs.baodao.$el.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.honer {
  height: 100%;
  width: 100%;

  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  border: 1px solid #e4e7ed;
  //   padding: 20px 20px;
  display: flex;
  flex-direction: column;
  .demo-ruleForm {
    padding: 0 0 0 10px;
    flex: 1;
    overflow-y: scroll;
  }
}
/deep/.el-input__inner {
  height: 36px;
}
.sub {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
  margin-right: 10px;
  /deep/.el-button {
    font-size: 0.875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    padding: 0.7rem 0.8rem;
    border: none;
  }
}
.el-form-item {
  width: 35%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 83px;
  height: 83px;
  line-height: 83px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}
.avatar {
  width: 83px;
  height: 83px;
  display: block;
}
.annotations {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
/deep/.el-form-item {
  margin-bottom: 15px;
}

.border {
  border: 1px solid #e4e7ed;
  padding-top: 10px;
  margin-bottom: 5px;
}
</style>